import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./api";
import {
  replaceTrackWithRelease,
  transformKeysToCamelCase,
} from "../utils/utils";

export const tracksApi = createApi({
  reducerPath: "tracksApi",
  baseQuery: axiosBaseQuery,
  tagTypes: ["favoriteTracks", "favoriteTrack"],
  endpoints: (builder) => ({
    rateTrack: builder.mutation({
      query: ({ trackId, rating }) => ({
        url: "track/rate",
        method: "POST",
        data: { track_id: trackId, rating },
      }),
      invalidatesTags: (_result, _error, { trackId, rating }) =>
        rating ? [{ type: "favoriteTrack", id: trackId }] : [],
    }),

    getFavoriteTracks: builder.infiniteQuery({
      infiniteQueryOptions: {
        initialPageParam: {
          offset: 0,
          limit: 50,
        },
        getNextPageParam: (
          lastPage,
          _allPages,
          lastPageParam,
          _allPageParams,
        ) => {
          const nextOffset = lastPageParam.offset + lastPageParam.limit;

          if (lastPage.total < lastPageParam.limit) {
            return undefined;
          }

          return {
            ...lastPageParam,
            offset: nextOffset,
          };
        },
      },
      query: ({ pageParam: { offset } }) => ({
        url: `user/favorites/tracks/offset/${offset}`,
      }),
      transformResponse: (response) => {
        const camelCaseData = transformKeysToCamelCase(response);
        return replaceTrackWithRelease(camelCaseData).data;
      },
      providesTags: (result, _error, { currentTrackId }) => {
        if (!result) return ["favoriteTracks"];

        return [
          {
            type: "favoriteTrack",
            id: currentTrackId,
          },
          "favoriteTracks",
        ];
      },
    }),
  }),
});

export const { useGetFavoriteTracksInfiniteQuery, useRateTrackMutation } =
  tracksApi;
